import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
/* Modules */
import { MaterialModule } from '@app/shared/modules/material.module';

/* Components */
import { SpinnerContentComponent } from './spinner-content.component';

@NgModule({
  declarations: [SpinnerContentComponent],
  imports: [CommonModule, MaterialModule],
  exports: [SpinnerContentComponent]
})
export class SpinnerContentModule {}
